export enum TmsCodes {
    care_hp_mobile = 'care_hp_mobile',
    care_hp_entrees = 'care_hp_entrees',
    care_hp_maison = 'care_hp_maison',
    care_hp_tvdivertissement = 'care_hp_tvdivertissement',
    care_hp_banque = 'care_hp_banque',
    care_hp_nsru = 'care_hp_nsru_sans_contrat_rattache',
    care_hp_multibal = 'care_hp_compte_secondaire_sans_contrat_rattache',
    care_hp_parnasse = 'care_hp_parnasse',
    care_hp_whousesit = 'care_hp_whousesit',
    care_hp_contrat_inactif = 'care_hp_contrat_inactif',
    care_selecteurcontrat_rapproche = 'care_selecteurcontrat_rapproche',
    care_hp_pro = 'care_hp_pro',
    care_hp_obs = 'care_hp_obs',
    care_digital_relational_zid = 'care-digital_accueil_top_relationnel',
    care_digital_relational_zidMob = 'care-digital_accueil-mob_top_relationnel',
    care_digital_relational_sosh_zid = 'care-digital_accueil-sosh_top_relationnel',
    care_digital_relational_sosh_zidMob = 'care-digital_accueil-sosh-mob_top_relationnel',
    care_digital_megapush_zid = 'care-digital_accueil_marchand_megapush',
    care_digital_megapush_zidMob = 'care-digital_accueil-mob_marchand_megapush',
    care_digital_megapush_sosh_zid = 'care-digital_accueil-sosh_marchand_megapush',
    care_digital_megapush_sosh_zidMob = 'care-digital_accueil-sosh-mob_marchand_megapush',
    care_digital_push_commercial_mobile_mob = 'care-digital_accueil-mob_marchand_mobile',
    care_digital_push_commercial_mobile = 'care-digital_accueil_marchand_mobile',
    care_digital_push_commercial_mobile_sosh_mob = 'care-digital_accueil-sosh-mob_marchand_mobile',
    care_digital_push_commercial_mobile_sosh = 'care-digital_accueil-sosh_marchand_mobile',
    care_digital_push_commercial_home_mob = 'care-digital_accueil-mob_marchand_home',
    care_digital_push_commercial_home = 'care-digital_accueil_marchand_home',
    care_digital_push_commercial_home_sosh_mob = 'care-digital_accueil-sosh-mob_marchand_home',
    care_digital_push_commercial_home_sosh = 'care-digital_accueil-sosh_marchand_home',
    care_digital_push_commercial_divertissement_mob = 'care-digital_accueil-mob_marchand_divertissement',
    care_digital_push_commercial_divertissement = 'care-digital_accueil_marchand_divertissement',
    care_digital_push_commercial_divertissement_sosh_mob = 'care-digital_accueil-sosh-mob_marchand_divertissement',
    care_digital_push_commercial_divertissement_sosh = 'care-digital_accueil-sosh_marchand_divertissement',
    care_digital_push_changermobile_mob = 'care-digital_accueil-mob_marchand_mobile-changermobile',
    care_digital_push_changermobile = 'care-digital_accueil_marchand_mobile-changermobile',
    care_digital_push_changermobile_sosh_mob = 'care-digital_accueil-sosh-mob_marchand_mobile-changermobile',
    care_digital_push_changermobile_sosh = 'care-digital_accueil-sosh_marchand_mobile-changermobile',
    care_digital_push_changeroffre_mobile_mob = 'care-digital_accueil-mob_marchand_changeroffre-mobile',
    care_digital_push_changeroffre_mobile = 'care-digital_accueil_marchand_changeroffre-mobile',
    care_digital_push_changeroffre_mobile_sosh_mob = 'care-digital_accueil-sosh-mob_marchand_changeroffre-mobile',
    care_digital_push_changeroffre_mobile_sosh = 'care-digital_accueil-sosh_marchand_changeroffre-mobile',
    care_digital_push_changeroffre_home_mob = 'care-digital_accueil-mob_marchand_changeroffre-home',
    care_digital_push_changeroffre_home = 'care-digital_accueil_marchand_changeroffre-home',
    care_digital_push_changeroffre_home_sosh_mob = 'care-digital_accueil-sosh-mob_marchand_changeroffre-home',
    care_digital_push_changeroffre_home_sosh = 'care-digital_accueil-sosh_marchand_changeroffre-home',
    care_digital_push_changeroffre_mob = 'care-digital_accueil-mob_marchand_changeroffre',
    care_digital_push_changeroffre = 'care-digital_accueil_marchand_changeroffre',
    care_digital_push_changeroffre_sosh_mob = 'care-digital_accueil-sosh-mob_marchand_changeroffre',
    care_digital_push_changeroffre_sosh = 'care-digital_accueil-sosh_marchand_changeroffre',
    care_digital_push_top_alert_mob = 'care-digital_accueil-mob_top_alert',
    care_digital_push_top_alert = 'care-digital_accueil_top_alert',
    care_digital_push_top_alert_sosh_mob = 'care-digital_accueil-sosh-mob_top_alert',
    care_digital_push_top_alert_sosh = 'care-digital_accueil-sosh_top_alert',
    care_digital_push_top_info_mob = 'care-digital_accueil-mob_top_helping',
    care_digital_push_top_info = 'care-digital_accueil_top_helping',
    care_digital_push_top_info_sosh_mob = 'care-digital_accueil-sosh-mob_top_helping',
    care_digital_push_top_info_sosh = 'care-digital_accueil-sosh_top_helping',
}
